<template>
  <div v-if="faq_edit">
    <b-row class="mb-2" no-gutters>
      <b-col cols="11" md="8">
        <div class="bg-white p-1 position-relative border" v-b-toggle="'collapse-'+faq_edit.id">        
          <div class="d-inline-block align-middle mx-2"><b>{{faq_edit.caption}}</b></div>
            <span class="when-opened float-right" style="font-size: 20px;">
              <b-icon icon="x" aria-hidden="true"></b-icon>            
            </span>
            <span class="when-closed float-right" style="font-size: 20px;">
              <b-icon icon="arrow-down-short" aria-hidden="true"></b-icon>           
            </span>                
        </div>
      </b-col>
      <b-col>
        <b-button @click="deleteFaq()" class="btn btn-danger" title="удалить">
            <b-icon icon="trash" aria-hidden="true"></b-icon>
          </b-button>
      </b-col>
    </b-row>
    
    <b-collapse :id="'collapse-'+faq_edit.id"> 
      <b-form class="border p-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-input-group prepend="Вопрос" class="mb-3">
          <b-form-input
            id="faq_caption"
            type="text"
            label="caption"
            v-model="faq_edit.caption"
            required
            placeholder="Вопрос"
          ></b-form-input>
        </b-input-group>
          </b-col>
        </b-row>        
        <b-form-group label="Ответ"  class="mt-2">
          <editor v-model="faq_edit.text"></editor>
        </b-form-group>         
        <b-button
          class="mt-3"
          variant="secondary"
          @click="changefaq()"
          title="Сохранить"
        >
          Сохранить
        </b-button>
      </b-form>
    </b-collapse> 
    <b-toast
      :title="toast.title"
      v-model="toast.show"
      :variant="toast.variant"
      autoHideDelay="5000"
      >{{ toast.message }}</b-toast
    >
  </div>
</template>
<script>
import Authentication from "@/components/pages/Authentication";
import Editor from "@/components/components/Editor.vue";
export default {
  props:['faq'],
  data() {
    return {
      faq_edit: this.faq,
      toast: {
        show: false,
        title: "",
        variant: "",
        message: "",
      },
    };
  },
  components:{
        'editor': Editor
    },
  methods: {
    showToast(data) {
      if (data) {
        if (data.success) {
          this.getfaq();
          this.toast = {
            show: true,
            title: "Выполнено",
            variant: "success",
            message: data.message,
          };
        } else {
          this.toast = {
            show: true,
            title: "Ошибка",
            variant: "danger",
            message: data.message,
          };
        }
      }
    },   
    async getfaq() {
      let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/faq/"+this.faq_edit.id,
        "get",
      );
      if (data) {
        this.faq_edit = data;
      }
    },
    async changefaq() {
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/changefaq",
        "post",
        {...this.faq_edit}
      );
      this.showToast(data);
    },
    deleteFaq(){
      this.$emit('delete-faq', this.faq_edit.id)
    }
  },
};
</script>
<style lang="scss">
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
</style>